import React, { useState } from 'react'
import { useRouter } from 'next/router'
import * as Yup from 'yup'
import snakeCase from 'lodash/snakeCase'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import SelectChecklist from 'components/SelectChecklist'
import FormMessage from 'components/FormMessage'

import FormsStore from 'stores/forms'
import AuthStore from 'stores/auth'
import { useStore } from 'hooks'
import pennData from 'lib/penn-analytics'
import { toJS } from 'mobx'

const HorsesWagerSchema = Yup.object().shape({
  horse_betting: Yup.string().trim().min(1, 'Please choose an option').required('Field is required')
})

const horsesWagerOptions = [
  {
    value: 'yes',
    label: 'Yes'
  },
  {
    value: 'no',
    label: 'No'
  }
]

const HorsesForm = () => {
  const router = useRouter()
  const formsStore = useStore(FormsStore)
  const authStore = useStore(AuthStore)
  const [submissionError, setSubmissionError] = useState(false)

  const handleSubmit = async ({ horse_betting }) => {
    // add info to the forms store
    formsStore.addFieldToSubmissionInProgress({
      prompt: 'Do you bet on horses?',
      answer: horse_betting
    })
    try {
      await formsStore.postSubmission(process.env.SPORTSBOOK_FORM_ID, formsStore.submissionInProgress)
      const fieldData = {}
      authStore.userId
      toJS(formsStore.submissionInProgress.fields).forEach(
        ({ prompt, answer }) => (fieldData[snakeCase(prompt)] = answer)
      )
      const identifyData = {
        id: authStore.userId,
        name: formsStore.submissionInProgress.name,
        email: formsStore.submissionInProgress.email,
        address_line_1: fieldData.address_line_1,
        address_line_2: fieldData.address_line_2,
        birth_date: fieldData.birth_date,
        city: fieldData.city,
        state: fieldData.state,
        zip: fieldData.zip_code,
        phone_number: fieldData.phone_number,
        first_name: fieldData.first_name,
        last_name: fieldData.last_name,
        gender: fieldData.gender
      }
      const trackData = {
        average_wager: fieldData.what_is_your_average_wager_when_betting_on_sports,
        bet_on_horses: fieldData.do_you_bet_on_horses,
        bet_on_casino_games: fieldData.do_you_play_casino_games,
        sport_bet_frequency: fieldData.how_often_do_you_bet_on_sports,
        favorite_sports: fieldData.what_are_your_favorite_sports,
        favorite_mlb_teams: fieldData.what_are_your_favorite_mlb_teams,
        favorite_nba_teams: fieldData.what_are_your_favorite_nba_teams,
        favorite_ncaa_teams: fieldData.what_are_your_favorite_ncaa_teams,
        favorite_nfl_teams: fieldData.what_are_your_favorite_nfl_teams,
        favorite_nhl_teams: fieldData.what_are_your_favorite_nhl_teams
      }
      pennData.identify(identifyData)
      pennData.track('userPreregistered', trackData)
      pennData.reset()
      formsStore.clearSubmissionInProgress()
      router.push('/barstool-sportsbook/thank-you')
    } catch (error) {
      setSubmissionError(true)
      console.error({ error })
    }
  }

  return (
    <Formik
      initialValues={{
        horse_betting: ''
      }}
      validationSchema={HorsesWagerSchema}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize={true}
      onSubmit={handleSubmit}
    >
      {({ values }) => (
        <Form className='sportsBookForm'>
          <Field name='horse_betting'>
            {({ field, form }) => <SelectChecklist {...field} {...form} options={horsesWagerOptions} />}
          </Field>
          <ErrorMessage name='horse_betting' component='div' className='field__error' />
          <br /> <br />
          {submissionError && (
            <FormMessage
              type='error'
              message='There was an error processing your submission, please refresh and try again.'
              showMessage
              handleDismiss={() => setSubmissionError(false)}
            />
          )}
          <button
            type='submit'
            className={`sportsBook__submitButton${!values?.horse_betting?.length ? '--disabled' : ''}`}
            disabled={!values?.horse_betting?.length}
          >
            Continue
          </button>
        </Form>
      )}
    </Formik>
  )
}

export default HorsesForm
